import { useRouteError } from "react-router-dom";
import {Col, Container, Row} from "react-bootstrap";

export default function ErrorPage() {
    const error = useRouteError();
    // @ts-ignore
    const errMsg = error?.statusText || error?.message || "";
    return (
        <Container fluid>
            <Row className={"justify-content-center align-content-center"}>
                <Col xs={"auto"}>
                    <h1>Оппааа!</h1>
                    <p>Възникна грешка, за което Ви се извиняваме.</p>
                    <p>
                        <i>{ errMsg }</i>
                    </p>
                </Col>
            </Row>
        </Container>
    );
}
